class GoogleCookieConsentUpdater {
    private cookieConsentData: HTMLScriptElement;
    private consentTypesMapping: Array<{ id: number, name: string }>;
    private consentValuesMapping: Array<string> = [];

    constructor() {
        this.initialize();
    }

    private initialize(): void {
        window.dataLayer = window.dataLayer || [];
        this.cookieConsentData = document.querySelector('[data-google-cookie-consent]');
        if (!this.cookieConsentData) {
            console.error("Nepodařilo se najít konfiguraci google consentu!");
        }

        const consentTypes = this.cookieConsentData.dataset.consentTypes;
        const consentValues = this.cookieConsentData.dataset.consentValues;
        if (!(consentTypes && consentValues)) {
            console.error("Nepodařilo se načíst konfiguraci google consentu, předaná data jsou pravděpodobně vadná!");
            return;
        }

        this.consentTypesMapping = JSON.parse(consentTypes);
        this.consentValuesMapping = JSON.parse(consentValues);
        document.addEventListener('cookiesConsentStored', (e) => this.onCookiesConsentStored(e.detail));
    }

    private translateBoolToConsent(value: boolean): string {
        return this.consentValuesMapping[Number(value)];
    }

    private onCookiesConsentStored(ev: { consent: number }): void {
        const consents = {};
        this.consentTypesMapping.forEach(t => consents[t.name] = this.translateBoolToConsent(t.id === (t.id & ev.consent)));
        this.updateConsent(consents);
        window.dataLayer.push({event: 'consent_updated'}); // Týká se měřících značek v GTM, které nejsou od Googlu
    }

    private updateConsent(consents): void {
        if (typeof gtag === "undefined") {
            console.error("Funkce gtag() nebyla inicializována. Nelze odeslat update consentu!");
            return;
        }

        gtag("consent", "update", consents);
    }

}


document.addEventListener('DOMContentLoaded', () => {
    new GoogleCookieConsentUpdater();
});